import { FC, useEffect, useState } from 'react'
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormSetValue,
  UseFormGetValues,
  UseFormSetError,
  UseFormHandleSubmit,
} from 'react-hook-form'
import Link from 'next/link'

import Button from 'components/parts/button/button'
import ControllerBaseInput from 'components/form-parts/controller-hook-forms/controller-base-input/controller-base-input'
import ControllerPhoneInput from 'components/form-parts/controller-hook-forms/controller-phone-input/controller-phone-input'
import ControllerSpecialitiesInput from 'components/form-parts/controller-hook-forms/controller-specialities-input/controller-specialities-input'
import CheckBox from 'components/parts/checkbox/checkbox'

import { PROD_STATIC_PATH } from 'constants/data'
import { A_startReg } from 'utils/analytics/other/registration/registration'
import { isAdAgree, isUserAgree, FormValues } from '../../data'
import { InputSpecialitiesStyles } from './data'
import { FieldsNameVoc, emailValidation, specialitiesValidation } from 'constants/auth/profile-data'
import { A_signinProgress, stepRegProgress } from 'utils/analytics/other/registration/registration'
import { RegStep } from '../../data'

import styles from './reg-flow.module.scss'
import common from '../../registration-code.module.scss'

interface IRegFlow {
  control: Control<FormValues>
  errors: FieldErrors
  clearErrors: UseFormClearErrors<FormValues>
  getValues: UseFormGetValues<FormValues>
  setValue: UseFormSetValue<FormValues>
  setError: UseFormSetError<FormValues>
  setStep: React.Dispatch<React.SetStateAction<RegStep>>
  handleSubmit: UseFormHandleSubmit<FormValues>
}

const RegFlow: FC<IRegFlow> = ({
  control,
  errors,
  setStep,
  setValue,
  getValues,
  setError,
  clearErrors,
  handleSubmit,
}) => {
  const [checkboxAd, setCheckboxAd] = useState(getValues()[isAdAgree])
  const [checkboxUser, setCheckboxUser] = useState(getValues()[isUserAgree])
  const isButtonDisabled = () => {
    return Boolean(!checkboxUser)
  }

  const enterHandler = () => {
    if (Object.keys(errors).length) return
    if (!checkboxUser) {
      setError(isUserAgree, { type: 'custom', message: 'Нет соглашения' })
      return
    }
    const userInfo = getValues()

    if (userInfo[FieldsNameVoc.countryCode] === 'RU') {
      setStep(RegStep.PHONE_FLOW_OK)
    } else {
      setStep(RegStep.EMAIL_FLOW_OK)
    }
  }

  const onChangeAgreeUser = () => {
    setValue(isUserAgree, !checkboxUser)
    setCheckboxUser(!checkboxUser)
    if (!checkboxUser === false) {
      setError(isUserAgree, { type: 'custom', message: 'Нет соглашения' })
    } else {
      clearErrors(isUserAgree)
    }
  }

  const onChangeAgreeAd = () => {
    setValue(isAdAgree, !checkboxAd)
    setCheckboxAd(!checkboxAd)
  }

  useEffect(() => {
    A_signinProgress(stepRegProgress.EMAIL)
    A_startReg()
    const currValues = getValues()
    setValue(FieldsNameVoc.email, currValues[FieldsNameVoc.email])
    setValue(FieldsNameVoc.phone, currValues[FieldsNameVoc.phone])
  }, [])

  return (
    <div className={common.wrapperCommon}>
      <div className={styles.title}>Регистрация</div>
      <div className={common.inputWrap}>
        <ControllerBaseInput
          control={control}
          name={FieldsNameVoc.email}
          errors={errors}
          nameStar
          noErrorOnTouch={clearErrors}
          rules={emailValidation}
        />
      </div>
      <div className={common.inputWrap}>
        <ControllerPhoneInput
          control={control}
          errors={errors}
          nameStar
          noErrorOnTouch={clearErrors}
          setValue={setValue}
        />
      </div>
      <div className={common.inputWrap} onClick={() => clearErrors(FieldsNameVoc.Specialities)}>
        <ControllerSpecialitiesInput
          control={control}
          rules={specialitiesValidation}
          errors={errors}
          nameStar
          nameInput="Специальность"
          {...InputSpecialitiesStyles}
        />
      </div>
      <div className={styles.checkboxUser}>
        <CheckBox checked={checkboxUser} noInnerHtml onChange={onChangeAgreeUser} />
        <div>
          Соглашаюсь с{' '}
          <Link href={`${PROD_STATIC_PATH}/terms.pdf`}>
            <p className={styles.checkboxLink}>Пользовательским соглашением</p>
          </Link>{' '}
          и
          <Link href={`${PROD_STATIC_PATH}/agreement.pdf`}>
            <p className={styles.checkboxLink}>условиями обработки</p>{' '}
          </Link>{' '}
          персональных данных
        </div>
      </div>
      <div className={styles.checkboxAd}>
        <CheckBox checked={checkboxAd} noInnerHtml onChange={onChangeAgreeAd}>
          Соглашаюсь на получение сообщений рекламного <span>характера</span>
        </CheckBox>
      </div>
      <Button
        modificator={styles.btn}
        disabled={isButtonDisabled()}
        onClick={handleSubmit(enterHandler)}
      >
        Зарегистрироваться
      </Button>
    </div>
  )
}

export default RegFlow
